import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography, Container } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { getmenuitems } from "../services/api";
import CardComponent from "../common/components/CardComponent";
//import { InteractionRequiredAuthError } from "@azure/msal-browser";

const LoginPage = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      // Start login
      const loginResponse = await instance.loginPopup(loginRequest);
      const account = loginResponse.account;
  
      if (!account) throw new Error("No account returned");
  
      localStorage.setItem(
        "user",
        JSON.stringify({
          emailaddress: account.username,
          name: account.name,
        })
      );

      //console.log("emailaddress: ", account.username);
      //console.log("name: ", account.name);

  
      // Try to get token silently
      let tokenResponse;
      try {
        tokenResponse = await instance.acquireTokenSilent({
          ...loginRequest,
          account,
        });
      } catch (silentError) {
        console.warn("Silent token acquisition failed. Trying popup.", silentError);
        // Fallback if token expired or cache issue
        tokenResponse = await instance.acquireTokenPopup({
          ...loginRequest,
          account,
        });
      }
  
      const accessToken = tokenResponse.accessToken;
  
      if (!accessToken) throw new Error("Access token missing");
  
      localStorage.setItem("accessToken", accessToken);
      const userMenu = await getmenuitems(accessToken);
      localStorage.setItem("userId", userMenu.id ?? "unknown");
      localStorage.setItem("usermenu", JSON.stringify(userMenu));
      localStorage.setItem("acsIdentity", userMenu.ACSIdentity ?? "unknown");
      localStorage.setItem("workerid", userMenu.workerid ?? "unknown");
      localStorage.setItem("userguid", userMenu.userguid ?? "unknown");
      localStorage.setItem("ACSIdentityToken", userMenu.ACSIdentityToken ?? "unknown");
      localStorage.setItem("ACSIdentityExpiration", userMenu.ACSIdentityExpiration ?? "2026-08-07T04:05:32.240Z");
      localStorage.setItem("justLoggedIn", "true");
      navigate("/");
    } catch (error) {
      console.error("MSAL Login failed:", error);
      alert("Login failed. Please try again.");
    }
  };
  

  return (
    <Container
      maxWidth={false}
      className="ai-layout-signIn"
      disableGutters
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <Box sx={{ maxWidth: 400, width: 1 }}>
        <CardComponent
          title={
            <Typography sx={{ textAlign: "center", mt: 3 }}>
              Customer Campaign Management System (CCMS)
            </Typography>
          }
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleLogin}
            fullWidth
            size="large"
            sx={{ mb: 2 }}
          >
            Sign in
          </Button>
        </CardComponent>

        <Typography
          variant="caption"
          component="div"
          sx={{ textAlign: "center", my: 2 }}
        >
          &copy; 2026 CaraFin.ai, Financial Services. All Rights Reserved.
        </Typography>
      </Box>
    </Container>
  );
};

export default LoginPage;